<template>
  <div class>
    <SForm
      ref="formref"
      :url="formurl"
      method="put"
      :fields="formfields"
      :dataForm="rowdata"
      :before="formbefore"
      :handle="formhandle"
      labelWidth="150px"
      :inline="false"
      formStyle="width: 400px;"
    >
    </SForm>
  </div>
</template>

<script>
//import x from ''

export default {
  name: "addAdministrators",
  components: {},
  data() {
    return {
      formurl: "/user",
      rowdata: {},
      formfields: [
        {
          label: "管理员姓名",
          prop: "userName",
          placeholder:"请输入管理员姓名",
          rules:{ required: true, message: '请输入管理员姓名', trigger: 'blur'}
        },
        {
          label: "管理员账号",
          prop: "loginName",
          placeholder:"请输入管理员账号",
          rules:{ required: true, message: '请输入管理员账号', trigger: 'blur'}
        },
        {
          label: "手机号",
          prop: "mobile",
          placeholder:"请输入手机号",
          rules:{ required: true, message: '请输入手机号', trigger: 'blur'}
        },
        {
          label: "密码",
          prop: "password",
          type: "password",
          placeholder:"请输入密码",
          rules:{ required: true, message: '请输入密码', trigger: 'blur'}
        }
      ],
      
      formbefore: record => {
        console.log(record);
        return record;
      },
      formhandle: record => {
        this.$router.go(-1)
      }
    };
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>

</style>



// WEBPACK FOOTER //
// src/views/BMS/userManagement/addAdministrators.vue